import 'slick-carousel/slick/slick.scss'
import '../../../assets/css/slick-theme.scss'

import React, { useState } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import TypographyAtom from '../../atoms/typography/typography'
import {brandIvory, brandOrange, brandSlate, brandWhite} from '../../../assets/consts/color'
import { GatsbyImage } from 'gatsby-plugin-image'
import './customSliderStyles/reviewsSliderStyle.scss'
import QuotesIcon from '../../atoms/icons/QuotesIcon'
import { primaryFont } from '../../../assets/consts/fonts'
import ArrowUpLeftIcon from '../../atoms/icons/ArrowUpLeftIcon'

const Container = styled.button`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 42px 42px;
    border-color: transparent transparent transparent ${brandWhite};
  }
`

const ReviewItem = styled.div`
  height: 260px;

  background-color: ${brandIvory};
`

const ReviewWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;

  //background-color: ${brandOrange};

  div {
    margin: 0;
  }

  & > div:first-of-type {
    flex-grow: 1;
  }

  p,
  svg {
    font-family: ${primaryFont};
    text-align: left;
    font-size: 16px;
    font-weight: 300;
    color: ${brandSlate};
  }
    
  p {
    &.review-reviewer {
        max-height: 10%;
        margin: 0;
        font-size: 16px !important;
        font-weight: 300 !important;
    }

    &.review-author {
        margin: 0;
        font-size: 20px;
        font-weight: 300;
    }

    &.review-company {
        font-size: 14px;
      }
  }  
    
  @media only screen and (min-width: 48em) {
    padding: 48px;
  }
`

const ArrowWrapper = styled.span`
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;

  transform: rotate(${({ open }) => (open ? '180deg' : '0deg')});

  @media only screen and (min-width: 48em) {
    bottom: 24px;
    right: 24px;
  }
`

const LogoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;

  background-color: ${brandIvory};
`
const ScrollableContainer = styled.div`
  overflow-y: auto;
  scrollbar-width: thin;
  max-height: 85%;
  //height: 140px;
`

function ReviewItemComponent({ reviewContent, authors, positionAndCompany }) {
  return (
    <Container>
      <ReviewWrapper>
        {/*<div className="flex column gap-32">*/}
          {/*<QuotesIcon />*/}
          <ScrollableContainer>
            <TypographyAtom type="BlockTextReview" weight="Regular" copyBlock={reviewContent} />
          </ScrollableContainer>
        {/*</div>*/}
        <div className="flex column gap-8">
          <TypographyAtom
            className="review-reviewer"
            type="ReviewSign"
            weight="Regular"
            copy={`${authors}${positionAndCompany ? `, ${positionAndCompany}` : ''}`}
          />
          {/*{positionAndCompany && (*/}
          {/*  <TypographyAtom*/}
          {/*    className="review-company"*/}
          {/*    type="ReviewSign"*/}
          {/*    weight="Regular"*/}
          {/*    copy={positionAndCompany}*/}
          {/*  />*/}
          {/*)}*/}
        </div>
      </ReviewWrapper>
    </Container>
  )
}

function ReviewCarousel({ reviews = [] }) {
  const carouselSettings = {
    dots: true,
    infinite: reviews.length > 3,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    centerPadding: '20px',
    className: 'reviews-slider-style',
    // responsive: [
    //   {
    //     breakpoint: 1440,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 3,
    //     },
    //   },
    //   {
    //     breakpoint: 1260,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 2,
    //     },
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  }

  return (
    <Slider {...carouselSettings}>
      {reviews.map(({ id, reviewContent, authors, positionAndCompany }) => (
        <ReviewItem key={id}>
          <ReviewItemComponent
            reviewContent={reviewContent}
            authors={authors}
            positionAndCompany={positionAndCompany}
          />
        </ReviewItem>
      ))}
    </Slider>
  )
}

export default ReviewCarousel
